import { Autocomplete, Popper, SxProps, TextField, Theme } from "@mui/material"
import { isNil } from "lodash"
import { trackerApi } from "../../core/api/TrackerApi"
import { useQueryArray } from "../../core/components/helpers/queryHelper"
import { LocationDto } from "../locations/LocationDtos"
import UseAutocomplete from "../../core/components/autocomplete/UseAutocomplete"





const fetchSubLocation = async (locationId?: number) => {
    let data: Array<LocationDto> = await trackerApi.callServiceGet("/oot/location/sublocations", [{name: "locationId", value: locationId}])

    return data;
}

export const useQuerySubLocationAutocomplete = (locationId?: number) => {

    let query = useQueryArray<LocationDto>(["oot/location/sublocations/"+ locationId],() => fetchSubLocation(locationId), "Oot Location")

    return query;
}


const fetchLocation = async () => {
    let data: Array<LocationDto> = await trackerApi.callServiceGet("/oot/location")

    return data;
}

export const useQueryLocationAutocomplete = () => {

    let query = useQueryArray<LocationDto>(["oot/location"], fetchLocation, "Oot Location")

    return query;
}

interface LocationAutocompleteProps {
    sx?: SxProps<Theme>
    label?: string
    locationTypeId?: number,
    subLocationId?: number,
    additionalOnChange?: (value: LocationDto | null) => void,
    selection?: LocationDto | null
}


export const LocationQueryAutocomplete = (params: LocationAutocompleteProps) => {

    let { data } = useQueryLocationAutocomplete();

    if (!isNil(params.locationTypeId))
        data = data.filter(x => x.locationType?.id === params.locationTypeId);

    return <BaseLocationAutocomplete {...params} data={data} />
}

export const SubLocationQueryAutocomplete = (params: LocationAutocompleteProps) => {

    let { data } = useQuerySubLocationAutocomplete(params.subLocationId);

    return <BaseLocationAutocomplete {...params} data={data} />
}


export const SimpleLocationQueryAutocomplete = (params: LocationAutocompleteProps) => {

    let { data } = useQueryLocationAutocomplete();

    if (!isNil(params.locationTypeId))
        data = data.filter(x => x.locationType?.id === params.locationTypeId);

    data.forEach(x => x.autocompleteName = x.name);


    let autocomplete = UseAutocomplete({ options: data, sx: params.sx });

    return autocomplete

}



interface BaseLocationAutocompleteProps {
    data: Array<LocationDto>
    label?: string,
    additionalOnChange?: (value: LocationDto | null) => void,
    selection?: LocationDto | null
    sx?: SxProps<Theme>
}

export const BaseLocationAutocomplete = (params: BaseLocationAutocompleteProps) => {

    let { data } = params;

    return <Autocomplete
        options={data}
        renderInput={(props) => <TextField {...props} label={params.label} multiline sx={{ textAlign: "center" }} variant="standard" />}
        getOptionLabel={(o) => o.name}
        filterOptions={(o, v) => o.filter(x =>  x.tags.some(t => t.toLowerCase() === v.inputValue.toLowerCase()) ||   (x.tags.some(t => t.toLowerCase() !== v.inputValue.toLowerCase()) && (x.name.toLowerCase().includes(v.inputValue.toLowerCase()) || x.tags.some(t => t.toLowerCase().includes(v.inputValue.toLowerCase()))) ))}
        fullWidth
        sx={{ ...params.sx }}
        size='small'
        onChange={(e, v) => { params.additionalOnChange?.(v) }}
        value={params.selection}
        isOptionEqualToValue={option => option.id === params.selection?.id}
        PopperComponent={(props) => <Popper sx={{ width: "240px!important" }} {...props} />}
    />
}

